<!-- rendering from templates -->
<div class="panel-content" [innerHtml]="html | sanitizeHtml"></div>
<!-- rendering from templates end -->

<div class="panel-content">
  <div id="view-1" *ngIf="!isDownloadReady">
    <div id="format-radios">
      <span
        ><input
          [checked]="state.pdf"
          id="pdf"
          title="Portable Document Format. Preserves the fonts, formatting, graphics, and color of the map view. Excellent for sharing, direct inclusion document packages or reports, or keeping a simple record of a compiled view."
          class="radio-input"
          type="radio"
          name="type"
          value="pdf"
          (change)="onItemChange($event)"
        /><span class="size">PDF</span></span
      ><span
        ><input
          [checked]="state.png"
          id="png"
          class="radio-input"
          type="radio"
          title="Portable Network Graphics. An image format that supports lossless data compression designed for transferring images on the Internet for incorporation in all types of graphic compositions."
          name="type"
          value="png"
          (change)="onItemChange($event)"
        /><span class="size">PNG</span></span
      >
    </div>
    <input
      *ngIf="fileName === 'pdf'"
      id="print_title"
      class="panel-text-box"
      maxlength="100"
      placeholder="Enter map title here"
      type="text"
      [(ngModel)]="titleFile"
      (change)="fileTitle($event)"
      (keyup.enter)="createFile()"
    />
    <div class="button-container">
      <input
        type="checkbox"
        (change)="onSelect($event)"
        id="data_panel_hide"
        name="data_panel_hide"
        [checked]="panelHidden"
      /><span class="panel-text-box">Hide Data Panel</span><br /><a
        id="print-link"
        title="Creates a file of your chosen type."
        class="btn btn-default pull-right"
        (click)="createFile()"
        >Create file</a
      >
      <div class="clear"></div>
    </div>
  </div>
  <div id="view-2" *ngIf="isDownloadReady">
    <p class="panel-text">Your map file is ready.</p>
    <div class="button-container">
      <a
        style="color: #fff"
        id="download-map"
        download
        class="btn btn-primary pull-right download"
        (click)="downLoadFile()"
        >Download</a
      >
    </div>
  </div>
</div>
<div id="loading" *ngIf="!loaded"></div>
<div class="buttonDiv">
  <a class="closer closerToolTip">
    <img
      (click)="closeLeft()"
      class="closer-img common-btns tool-toolTip"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
    /><span
      class="tooltiptext tip-bottom"
      [innerHtml]="mapService.templatetoolTips['close_left_panel']"
    ></span>
  </a>
</div>
<ngx-spinner [fullScreen]="true" type="" size="medium" bdColor="rgba(0, 0, 0, 0)">
  <img style="width: 100px;" src="/assets/img/wheel.svg" alt="Girl in a jacket" width="100px" height="100px" >
  </ngx-spinner>